import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.channels.title',
    defaultMessage: 'Channels',
    description: 'title of the channels page',
  },
  create: {
    button: {
      id: 'pages.channels.create.button',
      defaultMessage: 'Create channel',
      description: 'Label of the create channel button',
    },
  },
  feedback: {
    confirmDeleteChannel: {
      title: {
        id: 'pages.channels.confirmDeleteChannel.title',
        defaultMessage: 'Delete Channel',
        description: 'title of the delete channel confirm',
      },
      description: {
        id: 'pages.channels.confirmDeleteChannel.description',
        defaultMessage: 'Are you sure you want to delete this channel?',
        description: 'description of the delete channel confirm',
      },
      actions: {
        cancel: {
          id: 'actions.cancel',
          defaultMessage: 'Cancel',
          description: 'label of the cancel button of the confirm delete channel dialog',
        },
        delete: {
          id: 'actions.delete',
          defaultMessage: 'Delete',
          description: 'label of the delete button of the confirm delete channel dialog',
        },
      },
    },
    channelDeleted: {
      id: 'pages.channels.feedback.channelDeleted',
      defaultMessage: 'Channel deleted',
      description: 'Success message of the channel deleted action',
    },
    channelNotDeleted: {
      id: 'pages.channels.feedback.channelNotDeleted',
      defaultMessage: 'Channel could not be deleted',
      description: 'Error message of the channel deleted action',
    },
  },
};

export default defineMessages(translations);
